import request from '../utils/request'

import service from '../config/services';

const { domain: { jimu } } = service;

//添加行为统计
export function addBehaviorstats(data) {
  return request({
    // url: `${jimu}/api/behaviorstats/add.do`,
    url: `${jimu}/api/behaviorstats/add.do`,
    method: 'get',
    params: data,
    hideError: true,
  })
}